// extracted by mini-css-extract-plugin
export var footer = "_nv-0";
export var inherit = "_nv-1";
export var input = "_nv-2";
export var modalContent = "_nv-3";
export var quillEditor = "_nv-4";
export var subtitle = "_nv-5";